import { createFileRoute } from '@tanstack/react-router'
import AuthSettings from '@/pages/settings/auth'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/settings/auth'
)({
  component: AuthSettings,
})